import { ShippingProtection } from 'mr-components';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useScreenDetector } from '../../components/custom-hooks/screen-detector';
import { setShipProAutoAdd } from '../../../common/settings';

const ShippingProtectionPage = props => {
  const { offer, isAutoAddedOnce, onToggle, mrCart } = props;
  const {
    theme,
    shipProOfferedVariant,
    offered,
    isShipProAddByDefault,
    currencyFormat,
    currencySymbol,
    decimalSymbol,
    thousandSeparator,
  } = offer;
  const { variants, images } = offered[0];
  const { cartDiscountText, isRefreshPageAfterProductAddition } = theme;
  const { isMobile: isMobileDevice } = useScreenDetector();

  const [isToggleOn, setIsToggleOn] = useState(false);

  let imageURL = '';
  if (images && images.length > 0) {
    imageURL = images[0].src;
  }

  let priceToDisplay = '';
  const variant = variants.find(ele => ele.id === shipProOfferedVariant.id);
  if (variant) {
    priceToDisplay = variant.priceFloat;
  }

  useEffect(
    () => {
      const isPresentInCart = mrCart.some(
        elem => elem.sp_variant_id === shipProOfferedVariant.id,
      );

      setIsToggleOn(isPresentInCart);
    },
    [JSON.stringify(mrCart)],
  );

  const autoAdd = async () => {
    await onToggle({
      isOn: true,
      selectedVariant: shipProOfferedVariant,
      variants,
      cartDiscountText,
      isRefresh: isRefreshPageAfterProductAddition,
    });
    setIsToggleOn(true);
    setShipProAutoAdd(true);
  };

  useEffect(
    () => {
      if (isShipProAddByDefault && !isAutoAddedOnce && !isToggleOn) {
        autoAdd();
      }
    },
    [isShipProAddByDefault],
  );

  const toggleHandler = async e => {
    e.preventDefault();
    await onToggle({
      isOn: !isToggleOn,
      selectedVariant: shipProOfferedVariant,
      variants,
      cartDiscountText,
      isRefresh: isRefreshPageAfterProductAddition,
    });
    setIsToggleOn(!isToggleOn);
  };

  return (
    <ShippingProtection
      isToggleOn={isToggleOn}
      toggleHandler={toggleHandler}
      theme={theme}
      isMobile={isMobileDevice}
      imageURL={imageURL}
      priceToDisplay={priceToDisplay}
      currencyFormat={currencyFormat}
      currencySymbol={currencySymbol}
      decimalSymbol={decimalSymbol}
      thousandSeparator={thousandSeparator}
    />
  );
};

export default ShippingProtectionPage;

ShippingProtectionPage.propTypes = {
  offer: PropTypes.object,
  onToggle: PropTypes.func,
  mrCart: PropTypes.any,
  isAutoAddedOnce: PropTypes.bool,
};
